import { useTranslation } from 'react-i18next'

const Office = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="office-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="office-title">{t('antagonists:politician:components:background')}</title>
      <defs>
        <clipPath id="office-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="office-c">
          <path
            style={{
              fill: '#d0b681',
            }}
            d="m1274.88 474.94 2.6 399.54 487.95-2.71v-392.1l-490.55-4.73z"
          />
        </clipPath>
        <clipPath id="office-d">
          <path
            d="m1572.81 117.96.46 187.46s6.18-.2 17.68-.2 22.49-.12 22.49-.12l-2.18-187.87s-11.53 1.09-19.58 1.09-18.86-.36-18.86-.36Z"
            style={{
              fill: '#ea683e',
            }}
          />
        </clipPath>
        <clipPath id="office-e">
          <path
            d="m1715.82 118.96.46 187.46s6.18-.2 17.68-.2 22.49-.12 22.49-.12l-2.18-187.87s-11.53 1.09-19.58 1.09-18.86-.36-18.86-.36Z"
            style={{
              fill: '#009250',
            }}
          />
        </clipPath>
        <clipPath id="office-f">
          <path
            d="m1278.33 116.4.46 187.46s6.18-.2 17.68-.2 22.49-.12 22.49-.12l-2.18-187.87s-11.53 1.09-19.58 1.09-18.86-.36-18.86-.36Z"
            style={{
              fill: '#ffe01c',
            }}
          />
        </clipPath>
        <clipPath id="office-g">
          <path
            d="m1435.26 126.51-110.13 151.7s5.11 3.48 14.4 10.26c9.29 6.78 18.24 13.15 18.24 13.15l108.98-153.04s-9.96-5.92-16.46-10.66c-6.5-4.75-15.02-11.41-15.02-11.41Z"
            style={{
              fill: '#00a990',
            }}
          />
        </clipPath>
        <clipPath id="office-h">
          <path
            d="m1621.35 116.27-6.5 187.35s7.88 2.64 19.37 3.06c11.49.43 20.77-1.9 20.77-1.9l4.79-187.82s-11.61.66-19.65.36c-8.05-.3-18.79-1.06-18.79-1.06Z"
            style={{
              fill: '#c4c7c9',
            }}
          />
        </clipPath>
        <clipPath id="office-i">
          <path
            d="m1664.79 119.96.58 187.46s7.3-.2 20.89-.2 26.57-.13 26.57-.13l-2.61-187.87s-13.63 1.09-23.14 1.09-22.29-.36-22.29-.36Z"
            style={{
              fill: '#352e50',
            }}
          />
        </clipPath>
        <clipPath id="office-j">
          <path
            d="m1522.17 115.93.58 187.46s7.3-.2 20.89-.2 26.57-.13 26.57-.13l-2.61-187.87s-13.63 1.09-23.14 1.09-22.29-.36-22.29-.36Z"
            style={{
              fill: '#352e50',
            }}
          />
        </clipPath>
        <clipPath id="office-k">
          <path
            d="m1468.44 115.93.58 187.46s7.3-.2 20.89-.2 26.57-.13 26.57-.13l-2.61-187.87s-13.63 1.09-23.14 1.09-22.29-.36-22.29-.36Z"
            style={{
              fill: '#352e50',
            }}
          />
        </clipPath>
        <clipPath id="office-l">
          <path
            style={{
              fill: '#0083c9',
            }}
            d="m1627.01 426.79 132.8-.55.88 27.29-134.67-.88.99-25.86z"
          />
        </clipPath>
        <clipPath id="office-m">
          <path
            style={{
              fill: '#ed7925',
            }}
            d="M1532.69 422.67v-12.39l89.13-1.18.59 11.8-89.72 1.77z"
          />
        </clipPath>
        <style>
          {
            '.o{fill:none}.p{fill:#f3e5d1}.q{fill:#f8c4b7}.r{fill:#f8f7f0}.s{fill:#00a990}.t{fill:#009250}.u{fill:#0083c9}.v{fill:#ed7925}.w{fill:#f19eb0}.x{fill:#f0f2f4}.y{fill:#f6a500}.aa{fill:#eed9bb}.ab{fill:#e2e6ea}.ac{fill:#ffe01c}.ad{fill:#ea683e}.ae{fill:#ea6727}.af{fill:#fee608}.ag{fill:#fbf8f6}.ah{fill:#80523e}.ai{fill:#bb974a}.aj{fill:#a5cedc}.ak{fill:#db1f81}.al{fill:#cbe4e8}.am{fill:#d0e0e1}.an{fill:#d0b681}.ao{fill:#d192bc}.ap{fill:#c4c7c9}.aq{fill:#444851}.ar{fill:#35af91}.as{fill:#9b9599}.at{fill:#2e425b}.au{fill:#352e50}.av{fill:#4a9055}.aw{fill:#50892c}.ax{clip-path:url(#office-c)}.ay{clip-path:url(#office-b)}.ba{clip-path:url(#office-e)}.bb{clip-path:url(#office-d)}.bc{clip-path:url(#office-m)}.bd{clip-path:url(#office-l)}.be{clip-path:url(#office-k)}.bf{clip-path:url(#office-j)}.bg{clip-path:url(#office-i)}.bh{clip-path:url(#office-h)}.bi{clip-path:url(#office-g)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#office-b)',
        }}
        id="office-a"
      >
        <path
          style={{
            fill: '#d0e0e1',
          }}
          d="M-132.24-178.23H2110.5v1501.21H-132.24z"
        />
        <path
          style={{
            fill: '#f8f7f0',
          }}
          d="m409.27-144.72 1.61 549.6 472.27-1.82v-553.24l-473.88 5.46z"
        />
        <path
          style={{
            fill: '#cbe4e8',
          }}
          d="m436.95-104.46-.75 467.66 201.82-.41-.02-463.73-201.05-3.52zM655.58-104.46l-.75 467.66 201.82-.41-.02-463.73-201.05-3.52z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#a5cedc',
          }}
          d="M-499.38 817.36h2991.09v952.85H-499.38z"
        />
        <path
          style={{
            fill: '#d192bc',
          }}
          d="m184.26 459.23 1.54-73.7-94.47.59-1.26 76.18 94.19-3.07z"
        />
        <path
          style={{
            fill: '#fee608',
          }}
          d="m192.07 472.24.64-63.35-105.9-.93 9.01 53.98 96.25 10.3z"
        />
        <path
          style={{
            fill: '#fbf8f6',
          }}
          d="m182.24 459.48-14.28-89.32-85.14 13.44 11.2 88.39 88.22-12.51z"
        />
        <path
          style={{
            fill: '#50892c',
          }}
          d="m198.18 547.18 1.3-94.45-84.75-53.69-43.99 4.05 1.56 146.02 125.88-1.93z"
        />
        <path
          style={{
            fill: '#bb974a',
          }}
          d="m38.43 919.49 1.3-356.09H283l1.3 358.02-245.87-1.93z"
        />
        <path
          style={{
            fill: '#eed9bb',
          }}
          d="m276.39 586.25-88.23 6.21-48.58.4-92.47-7.16-.37 64.03 230.02 2.23-.37-65.71zM276.01 657.53l-92.79 7.23-48.57.4-86.79-9.3.75 60.69h228.15l-.75-59.02zM276.76 721.56l-92.7 9-48.57.4-87.25-9.4-.75 56.8h229.65l-.38-56.8zM276.01 788.98l-94.61 7.28-48.57.4-85.34-9.9.37 89.09 229.28 1.67-1.13-88.54z"
        />
        <path
          style={{
            fill: '#bb974a',
          }}
          d="m531.67 919.49 1.3-356.09h243.26l1.31 358.02-245.87-1.93z"
        />
        <path
          style={{
            fill: '#eed9bb',
          }}
          d="m769.62 586.25-88.23 6.21-48.58.4-92.47-7.16-.37 64.03 230.02 2.23-.37-65.71zM769.25 657.53l-92.8 7.23-48.57.4-86.79-9.3.75 60.69h228.15l-.74-59.02zM769.99 721.56l-92.69 9-48.58.4-87.25-9.4-.75 56.8h229.65l-.38-56.8zM769.25 788.98l-94.62 7.28-48.57.4-85.34-9.9.37 89.09 229.28 1.67-1.12-88.54z"
        />
        <path
          style={{
            fill: '#9b9599',
          }}
          d="m337.54 491.54-12.2 60.32h65.16l-12.87-59.74-40.09-.58z"
        />
        <path
          d="M244.25 340.76c0 10.68-1.57 138.48-1.2 148.52.31 8.57 4.68 10.83 11.42 11.12 17.48.76 187.79.76 202.6.27 8.32-.27 12.36-1.9 12.36-10.8 0-15.36 1.01-143.85.73-152.76-.3-9.75-5.6-11.39-16.37-11.39-10.77 0-186.98-.88-195.72-.56-8.48.3-13.82 3.27-13.82 15.6Z"
          style={{
            fill: '#9b9599',
          }}
        />
        <path
          style={{
            fill: '#f0f2f4',
          }}
          d="m253.49 334.82-.79 153.03 209.13-.13-.02-151.76-208.32-1.14z"
        />
        <path
          style={{
            fill: '#f8c4b7',
          }}
          d="m182.46 543.87-2.79-5.4-5.4-78.14 2.05-1.48 2.6.74 5.4 77.58-1.86 6.7z"
        />
        <path
          style={{
            fill: '#db1f81',
          }}
          d="m201 540.87-3.92-5.45-18.5-84.46 1.99-1.96 2.97.4 18.41 83.85-.95 7.62z"
        />
        <path
          style={{
            fill: '#2e425b',
          }}
          d="m212.14 456.16-.76 2.32-1.93-.16-14.42 61.79.81 6.66 3.81-6.02 15.03-61.08-1.74-.77.44-2.43-1.24-.31z"
        />
        <path
          style={{
            fill: '#f6a500',
          }}
          d="m170.62 491.99 4.32 54.77 38.75-.56 4.02-53.58-47.09-.63z"
        />
        <path
          style={{
            fill: '#bb974a',
          }}
          d="m-93.08 544.78.58 23.71 924.52 2.35-.58-25.27-924.52-.79zM1242.06 53.54l5.75 921.04 547.24-1.89V53.54h-552.99z"
        />
        <path
          style={{
            fill: '#d0b681',
          }}
          d="m1274.88 474.94 2.6 399.54 487.95-2.71v-392.1l-490.55-4.73z"
        />
        <g
          style={{
            clipPath: 'url(#office-c)',
          }}
        >
          <path
            style={{
              fill: '#f3e5d1',
            }}
            d="m1239.83 835.69 589.35 1.03 1.66 22.93h-611.55l20.54-23.96zM1237.91 865.43l589.35 1.04 1.66 22.92h-611.55l20.54-23.96zM1243.25 806.02l589.87 2.29 1.14 21.67h-611.55l20.54-23.96zM1242.71 776.21l589.35 1.03 1.66 22.93h-611.55l20.54-23.96zM1246.13 746.54l589.87 2.28 1.14 21.68h-611.55l20.54-23.96zM1242.71 717.68l589.35 1.04 1.66 22.92h-611.55l20.54-23.96zM1246.13 688.02 1836 690.3l1.14 21.68h-611.55l20.54-23.96zM1234.07 658.2l589.35 1.03 1.66 22.93h-611.55l20.54-23.96zM1237.49 628.53l589.87 2.28 1.15 21.68h-611.55l20.53-23.96zM1232.15 598.71l589.35 1.04 1.66 22.92h-611.55l20.54-23.96zM1235.57 569.05l589.88 2.28 1.14 21.68h-611.55l20.53-23.96zM1233.11 540.19l589.35 1.03 1.66 22.93h-611.55l20.54-23.96zM1236.53 510.52l589.87 2.29 1.15 21.67H1216l20.53-23.96zM1240.37 482.7l589.87 2.28 1.14 21.68h-611.55l20.54-23.96z"
          />
        </g>
        <path
          style={{
            fill: '#80523e',
          }}
          d="m1272.67 79.02-1.38 226.09 496.83 2.69-2.69-225.59-492.76-3.19zM1272.67 324.53v129.39l494.34 4.43 2.22-132.71-496.56-1.11z"
        />
        <path
          d="M1527.4 497.01c-6.77-.95-10.39 2.41-11.39 6.78-1.04 4.59.43 10.23 6.78 11.77 6.46 1.56 12.34-2.61 12.74-7.46.37-4.63-1.36-10.14-8.13-11.09Z"
          style={{
            fill: '#444851',
          }}
        />
        <path
          d="m1572.81 117.96.46 187.46s6.18-.2 17.68-.2 22.49-.12 22.49-.12l-2.18-187.87s-11.53 1.09-19.58 1.09-18.86-.36-18.86-.36Z"
          style={{
            fill: '#ea683e',
          }}
        />
        <g
          style={{
            clipPath: 'url(#office-d)',
          }}
        >
          <path
            d="M1568.45 176.71s13.17.62 21.91.62c11.18 0 24.52-2.07 24.52-2.07l2.18 49.32s-15.96 2.9-26.11 2.9-23.21-1.45-23.21-1.45l.73-49.32Z"
            style={{
              fill: '#f5f2ed',
            }}
          />
        </g>
        <path
          d="m1715.82 118.96.46 187.46s6.18-.2 17.68-.2 22.49-.12 22.49-.12l-2.18-187.87s-11.53 1.09-19.58 1.09-18.86-.36-18.86-.36Z"
          style={{
            fill: '#009250',
          }}
        />
        <g
          style={{
            clipPath: 'url(#office-e)',
          }}
        >
          <path
            d="M1711.46 177.71s13.06.73 21.76 1.45c9.42.79 24.66-2.9 24.66-2.9l2.18 49.32s-15.96 2.9-26.11 2.9-23.21-1.45-23.21-1.45l.73-49.32Z"
            style={{
              fill: '#f5f2ed',
            }}
          />
        </g>
        <path
          d="m1278.33 116.4.46 187.46s6.18-.2 17.68-.2 22.49-.12 22.49-.12l-2.18-187.87s-11.53 1.09-19.58 1.09-18.86-.36-18.86-.36Z"
          style={{
            fill: '#ffe01c',
          }}
        />
        <g
          style={{
            clipPath: 'url(#office-f)',
          }}
        >
          <path
            d="M1273.98 175.15s13.06.73 21.76 1.45c9.42.79 24.66-2.9 24.66-2.9l2.18 49.32s-15.96 2.9-26.11 2.9-23.21-1.45-23.21-1.45l.73-49.32Z"
            style={{
              fill: '#f5f2ed',
            }}
          />
        </g>
        <path
          d="m1435.26 126.51-110.13 151.7s5.11 3.48 14.4 10.26c9.29 6.78 18.24 13.15 18.24 13.15l108.98-153.04s-9.96-5.92-16.46-10.66c-6.5-4.75-15.02-11.41-15.02-11.41Z"
          style={{
            fill: '#00a990',
          }}
        />
        <g
          style={{
            clipPath: 'url(#office-g)',
          }}
        >
          <path
            d="M1397.11 171.41s10.12 8.28 16.72 14c7.15 6.19 21.63 12.19 21.63 12.19l-27.31 41.13s-14.6-7.06-22.8-13.05c-8.2-5.99-17.9-14.85-17.9-14.85l29.66-39.42Z"
            style={{
              fill: '#f5f2ed',
            }}
          />
        </g>
        <path
          d="m1621.35 116.27-6.5 187.35s7.88 2.64 19.37 3.06c11.49.43 20.77-1.9 20.77-1.9l4.79-187.82s-11.61.66-19.65.36c-8.05-.3-18.79-1.06-18.79-1.06Z"
          style={{
            fill: '#c4c7c9',
          }}
        />
        <g
          style={{
            clipPath: 'url(#office-h)',
          }}
        >
          <path
            d="M1614.82 174.82s13.58-.14 22.25.91c9.39 1.13 24.19-.64 24.19-.64l.35 49.37s-16.05 2.31-26.2 1.93c-10.15-.38-23.14-2.31-23.14-2.31l2.55-49.26Z"
            style={{
              fill: '#fbf8f6',
            }}
          />
        </g>
        <path
          d="m1664.79 119.96.58 187.46s7.3-.2 20.89-.2 26.57-.13 26.57-.13l-2.61-187.87s-13.63 1.09-23.14 1.09-22.29-.36-22.29-.36Z"
          style={{
            fill: '#352e50',
          }}
        />
        <g
          style={{
            clipPath: 'url(#office-i)',
          }}
        >
          <path
            d="M1659.66 178.72s15.43.72 25.72 1.45c11.14.78 29.14-2.91 29.14-2.91l2.58 49.32s-18.86 2.91-30.86 2.91-27.43-1.45-27.43-1.45l.85-49.32Z"
            style={{
              fill: '#f8f7f0',
            }}
          />
        </g>
        <path
          d="m1522.17 115.93.58 187.46s7.3-.2 20.89-.2 26.57-.13 26.57-.13l-2.61-187.87s-13.63 1.09-23.14 1.09-22.29-.36-22.29-.36Z"
          style={{
            fill: '#352e50',
          }}
        />
        <g
          style={{
            clipPath: 'url(#office-j)',
          }}
        >
          <path
            d="M1517.04 174.68s15.43.72 25.72 1.45c11.14.78 29.14-2.91 29.14-2.91l2.58 49.32s-18.86 2.91-30.86 2.91-27.43-1.45-27.43-1.45l.85-49.32Z"
            style={{
              fill: '#f8f7f0',
            }}
          />
        </g>
        <path
          d="m1468.44 115.93.58 187.46s7.3-.2 20.89-.2 26.57-.13 26.57-.13l-2.61-187.87s-13.63 1.09-23.14 1.09-22.29-.36-22.29-.36Z"
          style={{
            fill: '#352e50',
          }}
        />
        <g
          style={{
            clipPath: 'url(#office-k)',
          }}
        >
          <path
            d="M1463.31 174.68s15.43.72 25.72 1.45c11.14.78 29.14-2.91 29.14-2.91l2.58 49.32s-18.86 2.91-30.86 2.91-27.43-1.45-27.43-1.45l.85-49.32Z"
            style={{
              fill: '#f8f7f0',
            }}
          />
        </g>
        <path
          style={{
            fill: '#0083c9',
          }}
          d="m1627.01 426.79 132.8-.55.88 27.29-134.67-.88.99-25.86z"
        />
        <g
          style={{
            clipPath: 'url(#office-l)',
          }}
        >
          <path
            style={{
              fill: '#35af91',
            }}
            d="m1666.45 460.9-1.65-39.61h42.08l-1.65 38.78-38.78.83z"
          />
        </g>
        <path
          style={{
            fill: '#f19eb0',
          }}
          d="m1628.8 385.77 129.52.55 1.49 36.5-130.77 1.25-.24-38.3z"
        />
        <path
          style={{
            fill: '#ea6727',
          }}
          d="m1659.63 413.95 67.47.83.68-18.78-68.15-1.13v19.08z"
        />
        <path
          style={{
            fill: '#4a9055',
          }}
          d="m1531.54 452.27 89.93-1.13v-26.71l-89.76 2.16-.17 25.68z"
        />
        <path
          style={{
            fill: '#ed7925',
          }}
          d="M1532.69 422.67v-12.39l89.13-1.18.59 11.8-89.72 1.77z"
        />
        <g
          style={{
            clipPath: 'url(#office-m)',
          }}
        >
          <path
            style={{
              fill: '#ffe01c',
            }}
            d="m1569.19 422.66-.25-17.4 42.01-1 .25 18.65-42.01-.25z"
          />
        </g>
        <path
          style={{
            fill: '#e2e6ea',
          }}
          d="m1550.63 447.01 45.23-.81-.39-15.08-45.15.88.31 15.01z"
        />
      </g> 
    </svg>
  )
}

export default Office
